import { render } from "./CopyProgramOutcomesDialog.vue?vue&type=template&id=d6454804"
import script from "./CopyProgramOutcomesDialog.vue?vue&type=script&lang=js"
export * from "./CopyProgramOutcomesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__